import { gettext } from '@eventbrite/i18n';
import escape from 'lodash/escape';
import { OrderAttendee } from '../../models/attendee';
import { CheckoutState } from '../../state';
import { getAttendees } from './typedOrderSelectors';

export const getMinimumQuantityErrorMessage = (state: CheckoutState) => {
    const attendees = getAttendees(state);

    const attendeesByTicketClassId = attendees.reduce<
        Record<
            string,
            NonNullable<OrderAttendee['ticketClass']> & {
                attendeesCount: number;
            }
        >
    >(
        (accum, attendee) => ({
            ...accum,
            [attendee.ticketClassId]: {
                ...accum[attendee.ticketClassId],
                ...attendee.ticketClass,
                attendeesCount:
                    (accum[attendee.ticketClassId]?.attendeesCount ?? 0) + 1,
            },
        }),
        {},
    );

    const ticketClassWithoutEnoughTicketsSelected = Object.values(
        attendeesByTicketClassId,
    ).find(
        ({ minimumQuantity, attendeesCount }) =>
            minimumQuantity > attendeesCount,
    );

    return ticketClassWithoutEnoughTicketsSelected
        ? gettext('%(ticketName)s quantity must be %(minQuantity)s or more.', {
              ticketName: `<b>${escape(
                  ticketClassWithoutEnoughTicketsSelected.name,
              )}</b>`,
              minQuantity:
                  ticketClassWithoutEnoughTicketsSelected.minimumQuantity,
          })
        : null;
};
